<section class="dashboard_content_sec">
    <div class="dashboard_bred_crumb">
        <ul>
            <li>
                <a [routerLink]="['/profile/course-listing']" routerLinkActive="active-link">
                    Home
                </a>
            </li>
            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>

            <li>
                <a [routerLink]="['/profile/course-listing']" routerLinkActive="active-link">
                    Course listing
                </a>
            </li>
            <li><img src="../../../../../assets/images/icons/bred_crumb_arrow.svg" alt=""></li>

            <li>
                <a [routerLink]="['/profile/course-post']" routerLinkActive="active-link">
                    Create new course
                </a>
            </li>
        </ul>
    </div>

    <section class="master_add_sec">
        <form class="form-section" [formGroup]="coursePostForm" (ngSubmit)="submitCourse()">

            <div class="jobSelectTheList jobSelectTheList-custom">
                <div class="section-header" style="margin-bottom: 16px;">
                    <span class="section-title" style="width: 81px; height: 30px;">Add Course</span>
                </div>
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">

                    <!-- Job Title -->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

                        <!-- Course Format -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="type">Course Format ( Type ) <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="custom-mat-select">
                                    <mat-select id="type" placeholder="Select course format" formControlName="type">
                                        <mat-option disabled>Select Course Format</mat-option>
                                        <mat-option *ngFor="let type of courseTypeData" [value]="type?.name"
                                            [disabled]="type?.name === 'Online Academy'"
                                            [ngClass]="{'online-academy-option': type?.name === 'Online Academy'}">
                                            {{ type?.name }}
                                        </mat-option>
                                    </mat-select>
                                    <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                                    <mat-error *ngIf="coursePostForm.get('type')?.hasError('required')">
                                        Type is required
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>

                    </div>


                    <!-- Company Name-->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">


                        <div class="custom-form-group">
                            <label class="custom-label" for="course_category_id">
                                Category <span class="star" style="display: inline-block !important;">*</span>
                            </label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="custom-mat-select">
                                    <mat-select placeholder="Select category" formControlName="course_category_id">
                                        <mat-option disabled>Select Category</mat-option>
                                        <mat-option *ngFor="let category of courseCategoryData" [value]="category.id">
                                            {{ category.name }}
                                        </mat-option>
                                    </mat-select>
                                    <img src="assets/images2/CaretDown.svg" class="custom-caret-icon" alt="Arrow" />
                                    <mat-error *ngIf="coursePostForm.get('course_category_id')?.hasError('required')">
                                        Category is required
                                    </mat-error>
                                </mat-form-field>


                            </div>
                        </div>


                    </div>

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">


                        <div class="custom-form-group">
                            <label class="custom-label" for="">Course Name <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field">
                                    <input matInput placeholder="Enter Course Name" formControlName="course_name" />
                                    <mat-error *ngIf="coursePostForm.get('course_name')?.hasError('required')">
                                        Course name is required
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>




                    </div>

                </div>

                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">


                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <div class="custom-form-group">
                            <label class="custom-label" for="startTime">
                                Start Time <span class="star" style="display: inline-block !important;">*</span>
                            </label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" color="warn" class="custom-time-feild">
                                    <!-- Native time input bound to the reactive form control -->
                                    <input matInput type="time" id="startTime" placeholder="Select start time"
                                        formControlName="startTime">

                                    <mat-error *ngIf="coursePostForm.get('startTime')?.hasError('required')">
                                        Start Time is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>


                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <div class="custom-form-group">
                            <label class="custom-label" for="endTime">
                                End Time <span class="star" style="display: inline-block !important;">*</span>
                            </label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" color="warn">
                                    <!-- Native time input bound to the reactive form control -->
                                    <input matInput type="time" id="endTime" placeholder="Select end time"
                                        formControlName="endTime">

                                    <mat-error *ngIf="coursePostForm.get('endTime')?.hasError('required')">
                                        End Time is required
                                    </mat-error>
                                    <mat-error *ngIf="coursePostForm.get('endTime')?.hasError('endBeforeStart')">
                                        End time must be later than Start time
                                    </mat-error>

                                </mat-form-field>
                            </div>
                        </div>


                    </div>

                </div>


                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">

                    <!-- Start Date-->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column" *ngIf="showCourseDate">

                        <!-- Conditionally show date range -->
                        <div class="custom-form-group">
                            <label class="custom-label">Start Date <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control date-range">
                                <mat-form-field appearance="outline">
                                    <input matInput [matDatepicker]="startPicker" placeholder="Start Date"
                                        [formControl]="coursePostForm.get('startDate')" [min]="today">
                                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startPicker></mat-datepicker>
                                    <mat-error *ngIf="coursePostForm.get('startDate')?.hasError('required')">
                                        Start date is required
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>

                    </div>

                    <!-- End Date -->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column" *ngIf="showCourseDate">

                        <!-- Conditionally show date range -->
                        <div class="custom-form-group">
                            <label class="custom-label">End Date <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control date-range">

                                <mat-form-field appearance="outline">
                                    <input matInput [matDatepicker]="endPicker" placeholder="End Date"
                                        [formControl]="coursePostForm.get('endDate')"
                                        [min]="coursePostForm.get('startDate')?.value"
                                        [disabled]="!coursePostForm.get('startDate')?.value">
                                    <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #endPicker></mat-datepicker>
                                    <mat-error *ngIf="coursePostForm.get('endDate')?.hasError('required')">
                                        End date is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <!-- Course Address -->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column" *ngIf="showAddressField">
                        <!-- <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column"> -->

                        <div class="custom-form-group">
                            <label class="custom-label" for="">Address</label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field">
                                    <input matInput placeholder="Enter Address" formControlName="address"
                                        #addressSearch />

                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">

                    <!-- Job Title -->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

                        <div class="custom-form-group">
                            <label class="custom-label">RSVP Date <span class="star" *ngIf="isRsvpRequired"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control date-range">
                                <mat-form-field appearance="outline">
                                    <input matInput [matDatepicker]="startPicker" placeholder="RSVP Date"
                                        [formControl]="coursePostForm.get('rsvp_date')" [min]="today"
                                        [max]="getEarlyBirdMaxDate()">
                                    <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #startPicker></mat-datepicker>
                                    <mat-error *ngIf="coursePostForm.get('rsvp_date')?.hasError('required')">
                                        RSVP date is required
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>


                    </div>

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

                        <!-- Course Format -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="type"> Presented By ( Name ) <span class="star"
                                    style="display: inline-block !important;">*</span> </label>

                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field">
                                    <input matInput placeholder="Enter Presenter Name"
                                        formControlName="presented_by_name" />
                                    <mat-error *ngIf="coursePostForm.get('presented_by_name')?.hasError('required')">
                                        Name is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <div class="custom-form-group">
                            <label class="custom-label">Presented By ( Image ) <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <div class="presenter-upload-wrapper" style="padding: 6px !important;">

                                    <div *ngIf="presenterImageUrl; else presenterUploader">
                                        <div class="presenter-uploaded-img">
                                            <ul class="presenter-uploaded-list">
                                                <li>
                                                    <img class="presenter-preview-img" [src]="presenterImageUrl"
                                                        alt="Presenter Image" />
                                                    <button mat-icon-button class="presenter-close-btn"
                                                        (click)="removePresenterImage()">
                                                        <mat-icon>close</mat-icon>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>


                                    <!-- <img class="presenter-upload-icon" src="assets/images2/Featured-icon.svg"
                                                alt="Upload Icon" />
                                            <p class="presenter-upload-text">Choose a file or drag & drop it here.
                                            </p>
                                            <p class="presenter-upload-subtext">JPEG, PNG formats, up to 5 MB</p> -->

                                    <ng-template #presenterUploader>
                                        <div class="presenter-dropzone">
                                            <label class="presenter-upload-btn">
                                                <input id="presenterFileInput" type="file" hidden accept="image/*"
                                                    (change)="uploadPresenterImage($event)" #fileInput
                                                    (click)="$event.stopPropagation()" />
                                                Browse File
                                            </label>
                                        </div>

                                    </ng-template>

                                </div>
                                <mat-error
                                    *ngIf="coursePostForm.get('presented_by_image')?.hasError('required') && coursePostForm.get('presented_by_image')?.touched">
                                    Image is required
                                </mat-error>


                            </div>
                        </div>
                    </div>

                </div>






                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">


                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

                        <div class="custom-form-group">
                            <label class="custom-label">Course Header Banner/Video <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <div class="master_uploader presenter-upload-wrapper">

                                    <!-- Dropzone for Banner Image/Video -->
                                    <div class="presenter-dropzone">
                                        <img class="presenter-upload-icon" src="assets/images2/Featured-icon.svg"
                                            alt="Upload Icon" />
                                        <p class="presenter-upload-text">Choose a file or drag & drop it here.</p>
                                        <p class="presenter-upload-subtext">JPEG, PNG, MP4 formats, up to 20 MB</p>
                                        <label class="presenter-upload-btn" for="bannerFileInput">
                                            <input id="bannerFileInput" type="file" hidden multiple
                                                accept="image/*,video/mp4" (change)="uploadCourseBannerMedia($event)" />
                                            Browse File
                                        </label>
                                    </div>

                                    <!-- Course Banner Previews -->
                                    <div class="uploaded_img">
                                        <ul>
                                            <li *ngFor="let media of courseBannerMedia; let k = index">
                                                <ng-container [ngSwitch]="true">
                                                    <!-- Image preview -->
                                                    <img *ngSwitchCase="media.type.startsWith('image/')"
                                                        [src]="media.url" alt="Banner Image" class="preview_img" />

                                                    <!-- Video preview -->
                                                    <video *ngSwitchCase="media.type.startsWith('video/')"
                                                        [src]="media.url" class="preview_img" controls muted
                                                        preload="metadata"></video>
                                                </ng-container>

                                                <div class="close_img">
                                                    <img src="assets/images/icons/close.svg"
                                                        (click)="removeCourseBannerMedia(k)" alt="Remove" />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <!-- Validation error -->
                                <mat-error
                                    *ngIf="coursePostForm.get('course_banner_video')?.hasError('required') && coursePostForm.get('course_banner_video')?.touched">
                                    At least one Header banner image is required
                                </mat-error>

                            </div>
                        </div>
                    </div>


                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

                        <div class="custom-form-group">
                            <label class="custom-label">Gallery <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <div class="master_uploader presenter-upload-wrapper">

                                    <!-- Dropzone for Gallery Images -->
                                    <div class="presenter-dropzone">
                                        <img class="presenter-upload-icon" src="assets/images2/Featured-icon.svg"
                                            alt="Upload Icon" />
                                        <p class="presenter-upload-text">Choose a file or drag & drop it here.</p>
                                        <p class="presenter-upload-subtext">JPEG, PNG formats, up to 5 MB</p>
                                        <label class="presenter-upload-btn" for="galleryFileInput">
                                            <input id="galleryFileInput" type="file" hidden multiple accept="image/*"
                                                (change)="uploadGalleryImages($event)" />
                                            Browse File
                                        </label>
                                    </div>

                                    <!-- Gallery Image Previews -->
                                    <div class="uploaded_img">
                                        <ul>
                                            <li *ngFor="let img of galleryImages; let i = index">
                                                <img [src]="img.url" alt="Gallery Image" class="preview_img" />
                                                <div class="close_img">
                                                    <img src="assets/images/icons/close.svg"
                                                        (click)="removeGalleryImage(i)" alt="Remove" />
                                                </div>
                                            </li>
                                        </ul>
                                    </div>

                                </div>

                                <!-- Validation error -->
                                <mat-error
                                    *ngIf="coursePostForm.get('course_gallery')?.hasError('required') && coursePostForm.get('course_gallery')?.touched">
                                    At least one gallery image is required
                                </mat-error>
                            </div>

                        </div>

                    </div>


                </div>

                <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px" style="margin-top: 20px;">

                    <!-- Course Description -->
                    <div fxLayout="column" fxFlex="100" fxFlexFill class="addform-50-column">
                        <div fxFlex="100" class="addform-50-column">

                            <div class="custom-form-group">
                                <label class="custom-label">Course Banner Image <span class="star"
                                        style="display: inline-block !important;">*</span></label>
                                <div class="custom-form-control">
                                    <div class="master_uploader presenter-upload-wrapper">

                                        <!-- Dropzone for Banner Image -->
                                        <div class="presenter-dropzone">
                                            <img class="presenter-upload-icon" src="assets/images2/Featured-icon.svg"
                                                alt="Upload Icon" />
                                            <p class="presenter-upload-text">Choose an image or drag & drop it here.</p>
                                            <p class="presenter-upload-subtext">JPEG, PNG formats, up to 20 MB</p>
                                            <label class="presenter-upload-btn" for="bannerImageInput">
                                                <input id="bannerImageInput" type="file" hidden multiple
                                                    accept="image/*" (change)="uploadCourseBannerImage($event)" />
                                                Browse File
                                            </label>
                                        </div>

                                        <!-- Course Banner Image Previews -->
                                        <div class="uploaded_img">
                                            <ul>
                                                <li *ngFor="let img of courseBannerImage; let k = index">
                                                    <img [src]="img.url" alt="Banner Image" class="preview_img" />
                                                    <div class="close_img">
                                                        <img src="assets/images/icons/close.svg"
                                                            (click)="removeCourseBannerImage(k)" alt="Remove" />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <!-- Validation error -->
                                    <mat-error
                                        *ngIf="coursePostForm.get('course_banner_image')?.hasError('required') && coursePostForm.get('course_banner_image')?.touched">
                                        At least one banner image is required
                                    </mat-error>
                                </div>

                            </div>

                        </div>

                    </div>


                </div>





                <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px" style="margin-top: 20px;">

                    <!-- Course Description -->
                    <div fxLayout="column" fxFlex="100" fxFlexFill class="addform-50-column">
                        <div fxFlex="100" class="addform-50-column">
                            <div class="custom-form-group">
                                <label class="custom-label">
                                    Course Description <span class="star"
                                        style="display: inline-block !important;">*</span>
                                </label>

                                <div class="custom-form-control" class="description-textarea">

                                    <textarea matInput placeholder="Enter Description" formControlName="description"
                                        rows="10" maxlength="500">
                                      </textarea>

                                </div>
                                <mat-error
                                    *ngIf="coursePostForm.get('description')?.hasError('required') && coursePostForm.get('description')?.touched">
                                    Description is required
                                </mat-error>

                            </div>
                        </div>

                    </div>


                </div>

                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px" style="margin-top: 20px;">


                    <!-- Presented Name-->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">

                        <!-- Course Format -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="type"> CPD points ( Hours ) <span class="star"
                                    style="display: inline-block !important;">*</span> </label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field">
                                    <input matInput type="number" min="0" placeholder="Enter CPD Points"
                                        formControlName="cpd_points" />
                                    <mat-error *ngIf="coursePostForm.get('cpd_points')?.hasError('required')">
                                        CPD points is required
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>


                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <div class="custom-form-group">
                            <label class="custom-label">Number of Seats <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control date-range" fxLayout="row" fxLayoutGap="16px">

                                <!-- Number of Seats Input -->
                                <mat-form-field appearance="outline" class="rounded-form-field" fxFlex>
                                    <input type="number" matInput placeholder="Enter Number of Seats"
                                        formControlName="number_of_seats" />
                                    <mat-error *ngIf="coursePostForm.get('number_of_seats')?.hasError('required')">
                                        Seats points is required
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>


                    </div>

                </div>
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">

                    <!-- Company Name-->
                    <div fxLayout="column" fxFlex="23" fxFlexFill class="addform-50-column">


                        <div class="custom-form-group">
                            <label class="custom-label">Total Price <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control date-range" fxLayout="row" fxLayoutGap="16px">

                                <!-- Afterwards Price -->
                                <mat-form-field appearance="outline" class="rounded-form-field" fxFlex>
                                    <input type="number" matInput placeholder="Total Price ($)"
                                        formControlName="afterwards_price" />
                                    <mat-error *ngIf="coursePostForm.get('afterwards_price')?.hasError('required')">
                                        Price is required
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>


                    </div>
                    <div fxLayout="column" fxFlex="23" fxFlexFill class="addform-50-column" *ngIf="coursePostForm.get('startDate')?.value &&
         !isToday(coursePostForm.get('startDate')?.value)">


                        <div class="custom-form-group">
                            <label class="custom-label">Early Bird Price <span
                                    *ngIf="coursePostForm.get('early_bird_price')?.disabled" style="color: #ff7000;">
                                    (It has expired)
                                </span> </label>
                            <div class="custom-form-control date-range" fxLayout="row" fxLayoutGap="16px">

                                <!-- Early Bird Price -->
                                <mat-form-field appearance="outline" class="rounded-form-field" fxFlex>
                                    <input type="number" matInput placeholder="Early Bird Price (₹)"
                                        formControlName="early_bird_price" />
                                    <mat-error
                                        *ngIf="coursePostForm.get('early_bird_price')?.hasError('lessThanTotal')">
                                        Early bird price must be less than Total price
                                    </mat-error>
                                </mat-form-field>



                            </div>
                        </div>


                    </div>

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column" *ngIf="coursePostForm.get('startDate')?.value &&
         !isToday(coursePostForm.get('startDate')?.value)">


                        <!-- Conditionally show date range -->
                        <div class="custom-form-group">
                            <label class="custom-label">Early Bird End Date </label>
                            <div class="custom-form-control date-range" fxLayout="row" fxLayoutGap="16px">



                                <mat-form-field appearance="outline" class="rounded-form-field" fxFlex>
                                    <input matInput [matDatepicker]="earlyBirdPicker" placeholder="Early Bird End Date"
                                        formControlName="early_bird_end_date" [min]="today"
                                        [max]="getEarlyBirdMaxDate()" />
                                    <mat-datepicker-toggle matSuffix [for]="earlyBirdPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #earlyBirdPicker></mat-datepicker>
                                    <mat-error *ngIf="
                            coursePostForm.get('early_bird_end_date')?.hasError('required') &&
                            coursePostForm.get('early_bird_end_date')?.touched
                            ">
                                        Date is required
                                    </mat-error>
                                </mat-form-field>

                            </div>
                        </div>


                    </div>

                </div>


            </div>



            <div class="jobSelectTheList jobSelectTheList-custom"
                *ngIf="coursePostForm.get('type')?.value !== 'Webinar'">
                <!-- Section Header -->
                <div class="section-header" style="margin-bottom: 18px;">
                    <span class="section-title" style="width: 157px;">Course Info</span>
                </div>

                <div fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">
                    <div fxFlex="100" class="addform-100-column">

                        <!-- Course Info Header -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="">Course Info <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-radio-group formControlName="event_type" fxLayout="row" fxLayoutGap="16px">
                                    <mat-radio-button value="single">Single Day Event</mat-radio-button>
                                    <mat-radio-button value="multiple">Multiple Day Event</mat-radio-button>

                                </mat-radio-group>
                                <mat-error
                                    *ngIf="coursePostForm.get('event_type')?.hasError('required') && coursePostForm.get('event_type')?.touched">
                                    Event type is required
                                </mat-error>

                            </div>
                        </div>


                        <div formArrayName="course_event_info" *ngIf="eventDaysForm.controls.length > 0">
                            <div *ngFor="let day of eventDaysForm.controls; let i = index" [formGroupName]="i"
                                class="custom-day-block"
                                style="position: relative; margin-top: 24px; border-top: 1px solid #eee; padding-top: 16px;">

                                <button *ngIf="isMultipleDayEvent" mat-icon-button color="warn"
                                    (click)="removeEventDay(i)" style="position: absolute; top: 0; right: 0;"
                                    aria-label="Remove Day">
                                    <mat-icon>close</mat-icon>
                                </button>

                                <label class="custom-label">Day {{ i + 1 }}</label>

                                <!-- Session Name & Date -->
                                <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="start stretch"
                                    fxLayout.xs="column">
                                    <div fxFlex="50" class="addform-50-column"
                                        *ngIf="coursePostForm.get('event_type')?.value !== 'single'">
                                        <div class="custom-form-group">
                                            <label class="custom-label">Session Name <span class="star"
                                                    style="display: inline-block !important;">*</span></label>
                                            <div class="custom-form-control">
                                                <mat-form-field appearance="outline" class="rounded-form-field">
                                                    <input matInput placeholder="Enter Session Name"
                                                        formControlName="name" />
                                                    <mat-error
                                                        *ngIf="eventDaysForm.at(i).get('name')?.hasError('required') && eventDaysForm.at(i).get('name')?.touched">
                                                        Session Name is required
                                                    </mat-error>

                                                </mat-form-field>
                                            </div>
                                        </div>
                                    </div>

                                    <div fxFlex="50" class="addform-50-column">
                                        <div class="custom-form-group">
                                            <label class="custom-label">Event Date <span class="star"
                                                    style="display: inline-block !important;">*</span></label>
                                            <div class="custom-form-control">
                                                <mat-form-field appearance="outline" class="rounded-form-field" fxFlex>
                                                    <!-- <input matInput [matDatepicker]="picker" placeholder="Choose date"
                                                        formControlName="date" /> -->

                                                    <input matInput [matDatepicker]="picker" placeholder="Choose date"
                                                        formControlName="date"
                                                        [min]="coursePostForm.get('startDate')?.value"
                                                        [max]="coursePostForm.get('endDate')?.value"
                                                        (dateChange)="onDatePicked($event, i)" />


                                                    <mat-datepicker-toggle matSuffix
                                                        [for]="picker"></mat-datepicker-toggle>
                                                    <mat-datepicker #picker></mat-datepicker>

                                                    <!-- Event Date error -->
                                                    <mat-error
                                                        *ngIf="eventDaysForm.at(i).get('date')?.hasError('required') && eventDaysForm.at(i).get('date')?.touched">
                                                        Event Date is required
                                                    </mat-error>
                                                </mat-form-field>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Session Info & Images -->
                                <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="start stretch"
                                    fxLayout.xs="column" *ngIf="coursePostForm.get('event_type')?.value !== 'single'">
                                    <div fxFlex="50" class="addform-50-column">
                                        <div class="custom-form-group">
                                            <label class="custom-label">Session Info <span class="star"
                                                    style="display: inline-block !important;">*</span></label>
                                            <div class="custom-form-control description-textarea">
                                                <textarea matInput rows="7" placeholder="Enter Information"
                                                    formControlName="info" maxlength="500"></textarea>
                                            </div>
                                            <!-- Session Info error -->
                                            <mat-error
                                                *ngIf="eventDaysForm.at(i).get('info')?.hasError('required') && eventDaysForm.at(i).get('info')?.touched">
                                                Session Info is required
                                            </mat-error>
                                        </div>
                                    </div>

                                    <div fxFlex="50" class="addform-50-column">
                                        <div class="custom-form-group">
                                            <label class="custom-label">Event Image <span class="star"
                                                    style="display: inline-block !important;">*</span></label>
                                            <div class="custom-form-control">
                                                <div class="master_uploader presenter-upload-wrapper">

                                                    <!-- Dropzone always visible -->
                                                    <div class="presenter-dropzone">
                                                        <img class="presenter-upload-icon"
                                                            src="assets/images2/Featured-icon.svg" alt="Upload Icon" />
                                                        <p class="presenter-upload-text">Choose a file or drag & drop it
                                                            here.</p>
                                                        <p class="presenter-upload-subtext">JPEG, PNG formats, up to 5
                                                            MB</p>
                                                        <label class="presenter-upload-btn" for="eventFileInput{{i}}">
                                                            <input id="eventFileInput{{i}}" type="file" hidden multiple
                                                                accept="image/*"
                                                                (change)="uploadEventImage($event, i)" />
                                                            Browse File
                                                        </label>
                                                    </div>

                                                    <!-- Image previews below -->
                                                    <div *ngIf="eventDaysForm.at(i).get('images')?.value.length > 0"
                                                        class="uploaded_img">
                                                        <ul>
                                                            <li
                                                                *ngFor="let img of eventDaysForm.at(i).get('images')?.value; let j = index">
                                                                <img [src]="img.url" alt="Event Image"
                                                                    class="preview_img" />
                                                                <!-- <button mat-icon-button class="presenter-close-btn"
                                                                    (click)="removeEventImage(i, j)"
                                                                    aria-label="Remove image">
                                                                    <mat-icon>close</mat-icon>
                                                                </button> -->
                                                                <div class="close_img">
                                                                    <img src="../../../../../../../assets/images/icons/close.svg"
                                                                        (click)="removeEventImage(i, j)" alt="Remove" />
                                                                </div>
                                                            </li>
                                                        </ul>

                                                    </div>

                                                </div>

                                                <!-- Images validation error -->
                                                <mat-error *ngIf="
        eventDaysForm.at(i).get('images')?.hasError('required') &&
        eventDaysForm.at(i).get('images')?.touched
      ">
                                                    At least one image is required
                                                </mat-error>
                                            </div>
                                        </div>


                                    </div>
                                </div>


                            </div>
                        </div>


                        <div *ngIf="isMultipleDayEvent" style="margin-top: 16px;">
                            <button mat-raised-button color="primary" (click)="addEventDay()">
                                <mat-icon>add</mat-icon> Add Day
                            </button>
                        </div>

                    </div>
                </div>



                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px" style="margin-top: 20px;">


                    <!-- Course Description -->
                    <div fxLayout="column" fxFlex="100" fxFlexFill class="addform-50-column"
                        *ngIf="coursePostForm.get('event_type')?.value !== 'multiple'">
                        <div fxFlex="100" class="addform-50-column">
                            <div class="custom-form-group">
                                <label class="custom-label">Topics Included </label>


                                <div class="custom-form-control" class="description-textarea">

                                    <textarea matInput placeholder="Enter Description" formControlName="topics_included"
                                        rows="10" maxlength="500">
                                         </textarea>

                                </div>

                                <!-- 
                                    <mat-error
                                        *ngIf="coursePostForm.get('topics_included')?.hasError('required') && coursePostForm.get('topics_included')?.touched">
                                        Event type is required
                                    </mat-error> -->


                            </div>

                        </div>
                    </div>
                </div>
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px" style="margin-top: 20px;">


                    <!-- Course Description -->
                    <div fxLayout="column" fxFlex="100" fxFlexFill class="addform-50-column"
                        *ngIf="coursePostForm.get('event_type')?.value !== 'multiple'">
                        <div fxFlex="100" class="addform-50-column">

                            <div class="custom-form-group">
                                <label class="custom-label">Learning Objectives </label>


                                <div class="custom-form-control" class="description-textarea">

                                    <textarea matInput placeholder="Enter Description"
                                        formControlName="learning_objectives" rows="10" maxlength="500">
                                         </textarea>

                                </div>

                                <!-- <mat-error
                                    *ngIf="coursePostForm.get('learning_objectives')?.hasError('required') && coursePostForm.get('learning_objectives')?.touched">
                                    Event type is required
                                </mat-error> -->

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="jobSelectTheList jobSelectTheList-custom">
                <!-- Section Header -->
                <div class="section-header" style="margin-bottom: 18px;">
                    <span class="section-title" style="width: 157px;">Terms & Conditions</span>
                </div>

                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">


                    <!-- Course Description -->
                    <div fxLayout="column" fxFlex="100" fxFlexFill class="addform-50-column">
                        <div fxFlex="100" class="addform-50-column">
                            <div class="custom-form-group">
                                <label class="custom-label">Sponsored by </label>
                                <div class="custom-form-control">
                                    <div class="master_uploader presenter-upload-wrapper">

                                        <!-- Dropzone for Sponsor Images -->
                                        <div class="presenter-dropzone">
                                            <img class="presenter-upload-icon" src="assets/images2/Featured-icon.svg"
                                                alt="Upload Icon" />
                                            <p class="presenter-upload-text">Choose a file or drag & drop it here.</p>
                                            <p class="presenter-upload-subtext">JPEG, PNG formats, up to 5 MB</p>
                                            <label class="presenter-upload-btn" for="sponsorFileInput">
                                                <input id="sponsorFileInput" type="file" hidden multiple
                                                    accept="image/*" (change)="uploadSponsorImages($event)" />
                                                Browse File
                                            </label>
                                        </div>

                                        <!-- Sponsor Image Previews -->
                                        <div class="uploaded_img">
                                            <ul>
                                                <li *ngFor="let img of sponsorImages; let j = index">
                                                    <img [src]="img.url" alt="Sponsor Image" class="preview_img" />
                                                    <div class="close_img">
                                                        <img src="assets/images/icons/close.svg"
                                                            (click)="removeSponsorImage(j)" alt="Remove" />
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>

                                    </div>

                                    <!-- Validation error -->
                                    <!-- <mat-error
                                        *ngIf="coursePostForm.get('sponsor_by_image')?.hasError('required') && coursePostForm.get('sponsor_by_image')?.touched">
                                        At least one sponsor image is required
                                    </mat-error> -->

                                </div>
                            </div>
                        </div>

                    </div>

                </div>




                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px" style="margin-top: 20px;">


                    <!-- Course Description -->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <div class="custom-form-group">
                            <label class="custom-label" for="description">
                                Terms & Conditions <span class="star" style="display: inline-block !important;">*</span>
                            </label>

                            <div class="custom-form-control" class="description-textarea">

                                <textarea matInput placeholder="Enter Terms & Conditions" formControlName="terms"
                                    rows="7" maxlength="500"></textarea>


                            </div>
                            <mat-error
                                *ngIf="coursePostForm.get('terms')?.hasError('required') && coursePostForm.get('terms')?.touched">
                                Terms & Conditions are required
                            </mat-error>
                        </div>
                    </div>
                    <!-- Course Description -->
                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <div class="custom-form-group">
                            <label class="custom-label" for="description">
                                Cancellation & Refund Policy <span class="star"
                                    style="display: inline-block !important;">*</span>
                            </label>

                            <div class="custom-form-control" class="description-textarea">

                                <textarea matInput placeholder="Enter Cancellation & Refund Policy"
                                    formControlName="refund_policy" rows="7" maxlength="500"></textarea>

                            </div>
                            <mat-error
                                *ngIf="coursePostForm.get('refund_policy')?.hasError('required') && coursePostForm.get('refund_policy')?.touched">
                                Policy is required
                            </mat-error>
                        </div>
                    </div>



                </div>

            </div>
            <div class="jobSelectTheList jobSelectTheList-custom">
                <!-- Section Header -->
                <div class="section-header" style="margin-bottom: 18px;">
                    <span class="section-title" style="width: 157px;">Contacts</span>
                </div>

                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <!-- Contact Name -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="contact_name">Name <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field" style="width: 100%;">
                                    <input matInput placeholder="Enter Name" formControlName="contact_name"
                                        id="contact_name" />
                                    <mat-error *ngIf="coursePostForm.get('contact_name')?.hasError('required')">
                                        Name is required
                                    </mat-error>

                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <!-- Contact Phone -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="contact_phone">Phone <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field" style="width: 100%;">
                                    <input matInput placeholder="Enter Phone" formControlName="contact_phone"
                                        id="contact_phone" maxlength="10" />
                                    <mat-error
                                        *ngIf="coursePostForm.get('contact_phone')?.hasError('required') && coursePostForm.get('contact_phone')?.touched">
                                        Phone is required
                                    </mat-error>
                                    <mat-error
                                        *ngIf="coursePostForm.get('contact_phone')?.hasError('pattern') && coursePostForm.get('contact_phone')?.touched">
                                        Enter a valid 10-digit phone number
                                    </mat-error>

                                </mat-form-field>
                            </div>
                        </div>
                    </div>



                </div>
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <!-- Contact Email -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="contact_email">Email <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field" style="width: 100%;">
                                    <input matInput type="email" placeholder="Enter Email"
                                        formControlName="contact_email" id="contact_email" />
                                    <mat-error
                                        *ngIf="coursePostForm.get('contact_email')?.hasError('required') && coursePostForm.get('contact_email')?.touched">
                                        Email is required
                                    </mat-error>
                                    <mat-error
                                        *ngIf="coursePostForm.get('contact_email')?.hasError('pattern') && coursePostForm.get('contact_email')?.touched">
                                        Enter a valid email address
                                    </mat-error>

                                </mat-form-field>
                            </div>
                        </div>
                    </div>

                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <!-- Contact Website -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="contact_website">Website <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field" style="width: 100%;">
                                    <input matInput type="url" placeholder="Enter Website URL"
                                        formControlName="contact_website" id="contact_website" />

                                    <mat-error
                                        *ngIf="coursePostForm.get('contact_website')?.hasError('required') && coursePostForm.get('contact_website')?.touched">
                                        Website is required
                                    </mat-error>
                                    <mat-error
                                        *ngIf="coursePostForm.get('contact_website')?.hasError('pattern') && coursePostForm.get('contact_website')?.touched">
                                        Enter a valid website URL
                                    </mat-error>

                                </mat-form-field>
                            </div>
                        </div>
                    </div>



                </div>
                <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="25px">


                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column">
                        <!-- Contact Website -->
                        <div class="custom-form-group">
                            <label class="custom-label" for="register_link">Register Link <span class="star"
                                    style="display: inline-block !important;">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field" style="width: 100%;">
                                    <input matInput type="url" placeholder="Enter Register Link"
                                        formControlName="register_link" id="register_link" />
                                    <mat-error
                                        *ngIf="coursePostForm.get('register_link')?.hasError('required') && coursePostForm.get('register_link')?.touched">
                                        Register link is required
                                    </mat-error>
                                    <mat-error
                                        *ngIf="coursePostForm.get('register_link')?.hasError('pattern') && coursePostForm.get('register_link')?.touched">
                                        Enter a valid Register Link
                                    </mat-error>

                                </mat-form-field>
                            </div>
                        </div>
                    </div>




                    <div fxLayout="column" fxFlex="50" fxFlexFill class="addform-50-column" *ngIf="showWebinarLink">
                        <div class="custom-form-group">
                            <label class="custom-label" for="webinar_link">Meeting Link <span class="star"
                                    style="display: inline-block !important;">*</span><span
                                    class="star">*</span></label>
                            <div class="custom-form-control">
                                <mat-form-field appearance="outline" class="rounded-form-field" style="width: 100%;">
                                    <input matInput type="url" placeholder="Enter Webinar Link"
                                        formControlName="webinar_link" id="webinar_link" />

                                    <mat-error *ngIf="coursePostForm.get('webinar_link')?.hasError('required')">
                                        Webinar link is required.
                                    </mat-error>
                                    <mat-error *ngIf="coursePostForm.get('webinar_link')?.hasError('pattern')">
                                        Enter a valid Webinar Link.
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>




                </div>

            </div>
            <div class="form_box">
                <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxLayout.lt-md="column"
                    fxLayoutAlign.lt-md="center center" style="height: 40px;">

                    <!-- Left Group: Draft & Preview -->
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.lt-md="column"
                        fxLayoutAlign.lt-md="center center" class="button-group">

                        <!-- Save as Draft -->
                        <button type="button" class="btn btn-sm save-btn" mat-button (click)="submitCourse('draft')">
                            Save as Draft
                        </button>

                        <!-- Preview -->
                        <!-- <button type="button" class="btn btn-sm save-btn" mat-button (click)="openCoursePreview()">
                            Preview
                        </button> -->
                        <button type="button" mat-button class="btn btn-sm save-btn" (click)="openCoursePreview()">
                            Preview
                        </button>

                    </div>

                    <!-- Right Group: Post & Cancel -->
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px" fxLayout.lt-md="column"
                        fxLayoutAlign.lt-md="center center" class="button-group">

                        <!-- Cancel -->
                        <button type="button" class="btn btn-sm save-btn" mat-button
                            [routerLink]="['/profile/course-listing']">
                            Cancel
                        </button>

                        <!-- Post Course -->
                        <button type="button" class="btn btn-sm save-btn" mat-button (click)="submitCourse('publish')">
                            {{ courseId ? 'Update' : 'Submit' }}
                        </button>
                    </div>
                </div>
            </div>



        </form>
    </section>


</section>